import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import ProfileTable from './ProfileTable';
import { Profile } from '../types';
import ExperiencedProfileTable from './ExperiencedProfileTable';

const ExperienceProfilesPage = ({ setLoader= false,
    addToast, user}) => {
  const { status } = useParams<{ status: string }>();
  const [profiles, setProfiles] = useState<any[]>([]);
    const [loader, setLoader1] = useState(false);
  const [tempProfiles , setTempProfiles] = useState<any[]>([]);

  return (
    <div className="p-0">
      <h1 className="text-xl font-bold text-[#0071bd] mb-6  bg-gray-100 p-3 rounded-md shadow-md">
       All Experienced Stored Profiles in DataBase
      </h1>
      <ExperiencedProfileTable setLoader={setLoader} addToast={addToast}  user={user} />
    </div>
  );
};

export default ExperienceProfilesPage;